<template>

    <v-card class="pa-6 " flat>

        <!-- Title -->
        <div class="text-center my-6">
            <div class="text-h5  mb-2">
                {{ t("$vuetify.feedbackTitle") }}
            </div>
            <div class="text-medium-emphasis">
                {{ t("$vuetify.feedbackDescription") }}
            </div>
        </div>

        <v-form @submit.prevent="submitFeedback" v-model="isValid">

            <!-- Name -->
            <v-text-field v-model="form.name" :label="t('$vuetify.nameOptional')" prepend-inner-icon="mdi-account"
                variant="outlined" density="comfortable" hide-details="auto" :rules="[rules.maxLength(100)]"
                class="mb-3" />

            <!-- Phone -->
            <v-text-field v-model="form.phone" :label="t('$vuetify.phoneOptional')" prepend-inner-icon="mdi-phone"
                variant="outlined" density="comfortable" hide-details="auto" :rules="[rules.maxLength(20)]"
                class="mb-4" />

            <!-- Ratings -->
            <v-row class="text-center mt-3 px-2">
                <v-col v-for="rating in ratings" :key="rating.key" cols="12" sm="4" class="pa-1">
                    <div class="mb-3 pa-4 border border-medium-emphasis rounded-lg">
                        <div class="d-flex align-center justify-center text-medium-emphasis mb-2">
                            <v-icon :color="rating.color" class="me-2">{{ rating.icon }}</v-icon>
                            <span class="text-subtitle-2">{{ t(rating.labelKey) }}</span>
                            <v-chip class="ms-2" v-if="form[rating.key]" :color="rating.color" variant="tonal"
                                size="x-small">{{ form[rating.key] }}</v-chip>
                        </div>
                        <v-rating v-model="form[rating.key]" clearable hover :active-color="rating.color"
                            :color="rating.color" empty-icon="mdi-heart-outline" half-icon="mdi-heart-half-full"
                            full-icon="mdi-heart" density="comfortable" />
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- Comment -->
            <v-textarea v-model="form.comment" :label="t('$vuetify.commentSuggestions')"
                prepend-inner-icon="mdi-comment-text-outline" variant="outlined" auto-grow rows="2" hide-details="auto"
                :rules="[rules.maxLength(1000)]" />

            <!-- Submit Button -->
            <v-btn type="submit" color="primary" size="large" block class="mt-4" :loading="loading"
                :disabled="!isValid">
                {{ t('$vuetify.submitFeedback') }}
            </v-btn>

            <!-- Alerts -->
            <v-slide-y-transition>
                <v-alert v-if="success" type="success" border="start" elevation="2" class="mt-4">
                    {{ t('$vuetify.feedbackSuccess') }}
                </v-alert>
            </v-slide-y-transition>

            <v-slide-y-transition>
                <v-alert v-if="error" type="error" border="start" elevation="2" class="mt-4">
                    ⚠️ {{ error }}
                </v-alert>
            </v-slide-y-transition>

            <!-- Thanks Snackbar -->
            <v-snackbar v-model="thanksSnackbar" color="green" timeout="2000" location="bottom">
                ✅ {{ t('$vuetify.feedbackThanks') }}
            </v-snackbar>

        </v-form>
    </v-card>

</template>

<script setup>
import { ref, inject } from 'vue'
import { useLocale } from 'vuetify'
import axios from 'axios'
import { toast } from "vuetify-sonner";
import { getCookie } from '@/HelperFunction'
const closeFeedbackDialog = inject('closeFeedbackDialog')
const { t } = useLocale();

const ratings = ref([
    { key: 'rate_items', labelKey: t("$vuetify.rateItems"), icon: 'mdi-food', color: 'green' },
    { key: 'rate_service', labelKey: t("$vuetify.rateService"), icon: 'mdi-account-tie', color: 'blue' },
    { key: 'rate_chef', labelKey: t("$vuetify.rateChef"), icon: 'mdi-chef-hat', color: 'orange' },
])

const initialFormState = {
    name: '',
    phone: '',
    comment: '',
    rate_items: 0,
    rate_service: 0,
    rate_chef: 0,
}

const form = ref({ ...initialFormState })

const loading = ref(false)
const success = ref(false)
const error = ref(null)
const isValid = ref(false)
const thanksSnackbar = ref(false)

const rules = {
    maxLength: (length) => (v) =>
        !v || v.length <= length || t('maxLength', { length }),
}

async function submitFeedback() {
    if (!isValid.value) return

    loading.value = true
    success.value = false
    error.value = null

    try {
        const payload = {
            ...form.value,
            cafe_order_id: getCookie('invoice') || null
        }

        await axios.post(route('feedback.store'), payload)

        // success.value = true
        // thanksSnackbar.value = true
        form.value = { ...initialFormState }

        // Notify parent and auto-close modal shortly after showing thanks
        closeFeedbackDialog()
        localStorage.setItem('sendFeedback_' + getCookie('invoice'), '1')
        // setTimeout(() => emit('close'), 2000)
        toast(t("$vuetify.feedbackThanks"), {
            cardProps: {
                color: "green",
                class: "text-right",
            },
            progressBar: true,
        });

        // setTimeout(() => success.value = false, 4000)

    } catch (err) {
        error.value = err.response?.data?.message || t('feedbackErrorGeneric')
        setTimeout(() => error.value = null, 4000)

    } finally {
        loading.value = false
    }
}
</script>
